import type { AllRouteEndpoints } from "../routeTypes";
export const engagementAppGroupIdFeatureFlagsUpdateTagsCacheKeys: AllRouteEndpoints[] = [
  "/engagement/feature_flag_rollouts_data",
  "/engagement/:app_group_id/feature_flags/tags",
];
